module.exports = __webpack_public_path__ + "img/head_d.c3453130.png";